goog.provide('el8.ptdata.vipAccessNotifications');

goog.require('el8.model.base');
goog.require('el8.service.urls');


/**
 * Notifications that someone has accessed a VIP chart
 */
el8.ptdata.vipAccessNotifications = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addIntProperty('accessingUserId');
    _class.addStringProperty('accessingUserName', true);
    _class.addDateTime('accessDatetime', true);

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        mapped['canAcknowledge'] = el8.data.currUser.isPhysician() && (el8.ptdata.currPatient.getPrimaryPhysicianUserId() === el8.data.currUser.getId());

        return mapped;
    };

    _class.prototype.acknowledge = function(successCb) {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('acknowledgeVipAccessNotification', [this.getPatientId(), this.getId()]),
            success: function(data) {
                that.create(data);
                if (successCb) { successCb(); }
            }
        });
    };

    return that;

})();
